import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/guards/auth/auth.guard';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { ApproveUserModalComponent } from './modal/approve-user-modal/approve-user-modal.component';

const dashboardRouting: ModuleWithProviders<DashboardModule> = RouterModule.forChild([
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  }
]);

@NgModule({
  declarations: [
    DashboardComponent,
    ApproveUserModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    dashboardRouting
  ]
})
export class DashboardModule { }